export const NEXEN_POINT_START_DATE = '2023-07-01'
export const NEXEN_POINT_END_DATE = '2023-11-30'

export const NEXEN_TRIP_POINT_START_DATE = '2023-01-01'
export const NEXEN_TRIP_POINT_END_DATE = '2023-12-31'

export const TLP_POINT_START_DATE = '2025-01-01'
export const TLP_POINT_END_DATE = '2025-12-31'

export const TRIP_POINT_START_DATE = '2024-10-01'
export const TRIP_POINT_END_DATE = '2025-03-31'
